import React from 'react';

const NAV = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'inbound', label: 'Inbound' },
  { id: 'contacts', label: 'Contacts' },
  { id: 'campaigns', label: 'Campaigns' },
  { id: 'calls', label: 'History' },
];

const STATS = [
  { label: 'Active calls', value: '3', hint: 'Right now' },
  { label: 'In queue', value: '2', hint: 'Waiting for agent' },
  { label: "Today's calls", value: '147', hint: 'Since midnight' },
  { label: 'Agents online', value: '4/6', hint: 'Available now' },
];

const RECENT = [
  { name: 'Margaret Chen', phone: '+1 (555) 412-7733', outcome: 'completed', tone: 'ok', dur: '03:12', dir: 'in' },
  { name: 'James Wilson', phone: '+1 (555) 890-2244', outcome: 'voicemail', tone: 'vm', dur: '0:42', dir: 'out' },
  { name: 'Priya Nair', phone: '+1 (555) 604-1190', outcome: 'completed', tone: 'ok', dur: '05:48', dir: 'in' },
  { name: 'Aaron Blake', phone: '+1 (555) 227-0041', outcome: 'no answer', tone: 'warn', dur: '0:18', dir: 'out' },
];

const AGENTS = [
  { name: 'You (agent)', state: 'online' },
  { name: 'Cass Burton', state: 'on-call' },
  { name: 'Ilana Reyes', state: 'online' },
  { name: 'Marcus Lowe', state: 'offline' },
];

const STATE_COLOR = { online: '#4ade80', 'on-call': '#fbbf24', offline: '#6b7280' };

// Simulated operator console preview — visual only, not wired to live call data.
export default function OperatorConsole() {
  return (
    <div className="hiw-dashboard-preview oc-preview">
      <div className="hiw-preview-window">
        <div className="hiw-preview-header">
          <div className="hiw-dots"><span></span><span></span><span></span></div>
          <div className="hiw-address-bar">destiny.tavernix.io/dashboard</div>
        </div>
        <div className="hiw-preview-content">
          <div className="oc-sidebar">
            {NAV.map((n) => (
              <div key={n.id} className={`oc-nav-item${n.id === 'inbound' ? ' active' : ''}`}>
                {n.label}
              </div>
            ))}
          </div>

          <div className="oc-main">
            <div className="oc-stat-grid">
              {STATS.map((s) => (
                <div key={s.label} className="oc-stat-card">
                  <div className="oc-stat-label">{s.label}</div>
                  <div className="oc-stat-value">{s.value}</div>
                  <div className="oc-stat-hint">{s.hint}</div>
                </div>
              ))}
            </div>

            <div className="oc-columns">
              <div className="oc-recent">
                <div className="oc-panel-title">Recent calls</div>
                {RECENT.map((r) => (
                  <div key={r.phone} className="oc-recent-row">
                    <span className={`oc-dir oc-dir-${r.dir}`} />
                    <div className="oc-recent-info">
                      <span className="oc-recent-name">{r.name}</span>
                      <span className="oc-recent-phone">{r.phone}</span>
                    </div>
                    <span className={`oc-badge oc-badge-${r.tone}`}>{r.outcome}</span>
                    <span className="oc-recent-dur">{r.dur}</span>
                  </div>
                ))}
              </div>

              <div className="oc-agents">
                <div className="oc-panel-title">Team presence</div>
                {AGENTS.map((a) => (
                  <div key={a.name} className="oc-agent-row">
                    <span className="oc-dot" style={{ background: STATE_COLOR[a.state] }} />
                    <span className="oc-agent-name">{a.name}</span>
                    <span className="oc-agent-state">{a.state}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
